<div class="flex flex-column gap-3">
    <div class="grid m-0">
        <div class="col-12 md:col-6 pl-0">
            <label class="block mb-1">Tipo de datos</label>
            <p-dropdown [options]="types" [(ngModel)]="importType" placeholder="Selecciona un tipo"
                appendTo="body" styleClass="w-full"></p-dropdown>
        </div>

        <div class="col-12 md:col-6 pr-0">
            <label class="block mb-1">Modo</label>
            <p-dropdown [options]="modes" [(ngModel)]="mode" appendTo="body" styleClass="w-full"></p-dropdown>
        </div>

        <small *ngIf="uniquenessRule" class="uniqueness-rule col-12 px-0">
            <i class="pi pi-info-circle"></i> {{ uniquenessRule }}
        </small>
    </div>

    <div>
        <label class="block mb-1">Fichero Excel</label>
        <p-fileUpload mode="basic" chooseLabel="Seleccionar fichero" accept=".xlsx" [auto]="false"
                                    (onSelect)="onFileSelect($event)"></p-fileUpload>
        <small *ngIf="file">{{ file.name }}</small>
    </div>

    <div class="flex align-items-center gap-2">
        <p-inputSwitch [(ngModel)]="dryRun"></p-inputSwitch>
        <span>Modo prueba (no guarda datos)</span>
    </div>

    <div class="flex align-items-center gap-2">
        <p-inputSwitch [(ngModel)]="stopOnFirstError" [disabled]="dryRun"></p-inputSwitch>
        <span [class.text-400]="dryRun">Parar en el primer error</span>
    </div>

    <div class="flex align-items-center gap-2">
        <p-inputSwitch [(ngModel)]="allowDuplicates" [disabled]="!checksDuplicates"></p-inputSwitch>
        <span [class.text-400]="!checksDuplicates">Permitir duplicados</span>
    </div>

    <div class="flex align-items-center gap-2">
        <p-inputSwitch [(ngModel)]="truncateValues"></p-inputSwitch>
        <span>Truncar automáticamente los valores demasiado largos</span>
    </div>

    <div class="flex justify-content-end gap-2 mt-3">
        <button pButton label="Cancelar" class="p-button-text" (click)="cancel()"></button>
        <button pButton [label]="dryRun ? 'Probar' : 'Importar'" [icon]="dryRun ? 'pi pi-check-square' : 'pi pi-upload'"
                        [disabled]="!file || importType === null || submitting"
                        [loading]="submitting" (click)="submit()"></button>
    </div>
</div>

<p-dialog [(visible)]="showErrorsDialog" header="Errores en la plantilla" [modal]="true" [style]="{width: '700px'}">
    <p-table [value]="templateErrors">
        <ng-template pTemplate="header">
            <tr><th>Fila</th><th>Columna</th><th>Mensaje</th></tr>
        </ng-template>
        <ng-template pTemplate="body" let-e>
            <tr><td>{{ e.row }}</td><td>{{ e.column || '-' }}</td><td>{{ e.message }}</td></tr>
        </ng-template>
    </p-table>
</p-dialog>
